import React from 'react';

import { Typography } from '@mui/material';

import { Modal } from 'src/components/common';
import { InvitePartnershipByPlatformStaffModalContent } from 'src/components/partnership';
import { useModalV2 } from 'src/hooks/shared';
import { ModalV2Props } from 'src/types/modalV2';

export const InvitePartnershipByPlatformStaffModal: React.FC<ModalV2Props<unknown>> = ({ id }) => {
  const { closeModal, switchClosability } = useModalV2();

  const handleCloseModal = React.useCallback(() => {
    closeModal(id);
  }, [closeModal, id]);

  return (
    <Modal
      title="Invite a partner organization"
      maxWidth={740}
      headerPadding="32px 32px 8px 32px"
      dialogProps={{
        onClose: handleCloseModal,
        open: true,
      }}
    >
      <React.Fragment>
        <Typography variant="body1">
          Invite a partner organization using their email address. When selecting a partnership
          type, choose "Employer & PEO Partner" if you're unsure which clients this partner will
          bring.
        </Typography>

        <InvitePartnershipByPlatformStaffModalContent
          closeModal={handleCloseModal}
          switchClosability={switchClosability}
        />
      </React.Fragment>
    </Modal>
  );
};
